"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environments = void 0;
class Environments {
    static getEnvironment(domain, region) {
        if (this._environments[domain] && this._environments[domain][region]) {
            return this._environments[domain][region];
        }
        else {
            throw new Error('Unable to find requested environment');
        }
    }
}
exports.Environments = Environments;
Environments._environments = {
    localdev: {
        'us-west-2': {
            endpoint: process.env.A2S_APPSYNC_ENDPOINT_URL || 'https://a2s.beta.accelerate.proserve.aws.dev/graphql',
            userPoolId: process.env.USER_POOL_ID || 'us-west-2_x03PU1vmu',
        }
    },
    beta: {
        'us-west-2': {
            endpoint: 'https://a2s.beta.accelerate.proserve.aws.dev/graphql',
            userPoolId: 'us-west-2_x03PU1vmu',
        }
    },
    gamma: {
        'us-west-2': {
            endpoint: 'https://a2s.gamma.accelerate.proserve.aws.dev/graphql',
            userPoolId: 'us-west-2_tUnnJ4uzf',
        }
    },
    prod: {
        'us-west-2': {
            endpoint: 'https://a2s.accelerate.amazonaws.com/graphql',
            userPoolId: 'us-west-2_T18JUTBSR',
        }
    },
};
